"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _DialogButton = _interopRequireDefault(require("../DialogButton"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

/**
 * Vytvoří button pro zrušení akce. Pro použití v dialogu.

 * | Prop name | Type | Default | Description |
| -- | -- | -- | -- |
| color | string | primary | 'primary', 'secondary' |
| variant | string | flat | 'outlined', 'contained' |

 */
var DialogButtonCancel = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children"]);
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_DialogButton.default, (0, _extends2.default)({
    ref: ref
  }, rest), children || t('app/actions/cancel'));
});

DialogButtonCancel.displayName = 'DialogButtonCancel';

var _default = (0, _withThemeProps.default)({
  name: 'SxDialogButtonCancel'
})(DialogButtonCancel);

exports.default = _default;